import React from 'react'
import * as yup from "yup";

export const formSchema = yup.object().shape({
    newEmail: yup.string().email("Invalid email format").required("Email is required"),
    currentPassword: yup.string().required("Current Password is required"),
});